import { isValueExist, allValueExist, addIdUnless } from '@util';

export default {
    namespaced: 'true',
    state: getDefaultState(),
    mutations: {
        setSettingPanelVislble(state, value) {
            state.settingPanelVisible = value;
        },
    },
    actions: {},
};

function getDefaultState() {
    return {
        settingPanelVisible: true,
        folderData: {},
        mode: 'CREATE',
    };
}
